export default __webpack_public_path__ + "static/media/Gloves of the Stormbringer.511c3750.jpg";